import { render, staticRenderFns } from "./DrawingTools.vue?vue&type=template&id=b4dec6ec&scoped=true&"
import script from "./DrawingTools.vue?vue&type=script&lang=js&"
export * from "./DrawingTools.vue?vue&type=script&lang=js&"
import style0 from "./DrawingTools.vue?vue&type=style&index=0&id=b4dec6ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dec6ec",
  null
  
)

export default component.exports